






























import Vue from "vue";
import storeHelper from "../../store/store-helper";
import Utils from "../../utils";

export default Vue.extend({
    name: "DateSelector",
    components: {},
    props: {
        label: String,
        required: {
            type: Boolean,
            default: false
        },
        filled: {
            type: Boolean,
            default: true
        },
        defaultDate: {
            type: String,
            default: null
        },
        datePickerId: {
            type: String,
            default: "dateSelector"
        }
    },
    data: function () {
        return {
            dateSelected: null as string,
            showSelectDateMenu: false
        };
    },
    model: {
        prop: "dateSelected",
        event: "change"
    },
    beforeMount() {},
    methods: {
        async init() {
            if (this.defaultDate) this.dateSelected = this.defaultDate;
        }
    },
    computed: {
        requiredRules() {
            return [v => !!v || this.$t("general.validation.isRequired")];
        },
        formattedDate(): string {
            return this.dateSelected ? Utils.formatDate(new Date(this.dateSelected), storeHelper.userStore.loggedOnUser?.date_format) : null;
        },
        changedProps(): any {
            return {
                required: this.required,
                defaultDate: this.defaultDate
            };
        }
    },
    watch: {
        dateSelected(val) {
            this.$emit("change", this.dateSelected);
        },
        changedProps: {
            handler() {
                this.init();
            },
            immediate: true
        }
    }
});
